/* src/app/components/color-options/color-options.component.sass */
/*# sourceMappingURL=color-options.component.css.map */
